<template>
	<div>
		<locum-availability-set />
		<locum-upcoming-bookings />
		<locum-past-bookings />
		<locum-increase-availability-ad />
	</div>
</template>

<script>
import LocumAvailabilitySet from '@/components/ui/dashboard/locum/cards/LocumAvailabilitySet';
import LocumUpcomingBookings from '@/components/ui/dashboard/locum/dropdowns/LocumUpcomingBookings';
import LocumPastBookings from '@/components/ui/dashboard/locum/dropdowns/LocumPastBookings';

import LocumIncreaseAvailabilityAd from '@/components/ui/dashboard/locum/cards/LocumIncreaseAvailabilityAd';

export default {
	name: 'LocumSuccessAvailabilitySet',
	components: {
		LocumAvailabilitySet,
		LocumUpcomingBookings,
		LocumPastBookings,
		LocumIncreaseAvailabilityAd,
	},
	data: () => ({}),
};
</script>
